import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';

@Injectable({
  providedIn: 'root'
})
export class PagetagService extends BaseTableService<any> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/pagetag';
  }
  
}
